import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { GameBase } from '../games/game-base';
import { GameFactory } from '../games/game-factory';
import { BaccaratTableComponent } from '../games/main-games/baccaraat/baccarat-table.component';
import { DragonTigerTableComponent } from '../games/main-games/dragon-tiger/dragon-tiger-table.component';
import { ThreeHeadedDragonTableComponent } from '../games/main-games/three-headed-dragon/three-headed-dragon-table.component';
import { AppPhase, DealingSubPhase, GameType } from '../models/communication/app-enums.model';
import { CardDealtEvent } from '../models/communication/app-events.model';

@Component({
    selector: 'app-game-switch',
    standalone: true,
    imports: [CommonModule, DragonTigerTableComponent, BaccaratTableComponent, ThreeHeadedDragonTableComponent],
    templateUrl: './game-switch.component.html',
    styleUrl: './game-switch.component.scss'
})
/**
 * Generates the game table components based on the app state.
 * Initializes the game classes using the `GameFactory`.
 * Responsible for game instances' and relevant components' life cycles.
 *
 * It passes the relevant changes calling the `onChanges` method.
 * Enables the projection of the `app-count-down` component and
 * makes sure it is incorporated in the game table component UI.
 */
export class GameSwitchComponent implements OnChanges {
    @Input()
    gameType!: GameType;

    @Input()
    tableUpdate?: CardDealtEvent;

    @Input()
    appPhase!: AppPhase;

    @Input()
    subPhase?: DealingSubPhase;

    protected readonly AppPhase = AppPhase;
    protected readonly GameType = GameType;

    protected game?: GameBase;

    constructor(private readonly gameFactory: GameFactory) {}

    ngOnChanges(changes: Partial<SimpleChanges>): void {
        if (changes.gameType || (changes.appPhase && this.appPhase === AppPhase.NewRoundPreparation)) {
            this.initGame();
        }

        if (this.game) {
            this.game.onChanges(
                changes.tableUpdate && this.tableUpdate,
                changes.subPhase && this.subPhase,
                changes.appPhase && this.appPhase
            );
        }
    }

    initGame(): void {
        this.game = this.gameFactory.create(this.gameType);
    }
}
